/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_Column_PositionInputs */

const en_admin_user_detail_column_position = /** @type {(inputs: Admin_User_Detail_Column_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const de_admin_user_detail_column_position = /** @type {(inputs: Admin_User_Detail_Column_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle`)
};

/**
* | output |
* | --- |
* | "Position" |
*
* @param {Admin_User_Detail_Column_PositionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_column_position = /** @type {((inputs?: Admin_User_Detail_Column_PositionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_Column_PositionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_column_position(inputs)
	return en_admin_user_detail_column_position(inputs)
});